import {
  takeLatest, put, select, all, call,
} from 'redux-saga/effects';
import { message } from 'antd';
import { autoRequest } from '@api/createRequestStore';
import { get as sharingGet } from '@api/sharing';
import { applySavedIndex, updateZoomInterval } from '@store/comparison/actions';
import { TRIGGER_ADD_TAB } from '@store/dashboards/tabs/types';
import { SAVE_DASHBOARD_PROMPT_VISIBILITY } from '@store/dashboards/ui/types';
import { DASHBOARD_TYPE } from '@utils/constants';
import { addNewSharedTab } from '../../sharedTabs/action';

import selector, { compareSharingResponseSelector } from './selectors';
import * as types from './types';
import * as actions from './actions';

function* afterRequest() {
  const { state } = yield select(compareSharingResponseSelector);
  if (!state) {
    return;
  }

  try {
    const {
      comparison: { filterIndices },
      common: { selectedCustomerId },
      config: { zoomInterval },
    } = state;

    const { payload } = yield select(selector);
    yield put(applySavedIndex(filterIndices));
    yield call(updateZoomInterval, zoomInterval);
    yield put(
      addNewSharedTab(
        { id: payload, state, type: DASHBOARD_TYPE.COMPARE },
        selectedCustomerId,
      ),
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
}

function* initRequest() {
  yield put(actions.initRequest);
}

function* fetching({ id }) {
  yield actions.fetching();
  try {
    yield autoRequest(
      sharingGet,
      types.COMPARE_SHARING_SCOPE,
      id,
      afterRequest,
    );
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* addCompareSharingTab() {
  const compareSharing = yield select(compareSharingResponseSelector);
  if (!compareSharing) {
    return;
  }

  const { state, id } = compareSharing;

  try {
    const { config, name } = state;
    // after fetching sharing data, add a new tab data for user to save dashboard

    yield all([
      put({
        type: TRIGGER_ADD_TAB,
        payload: {
          config,
          dashboardTypeId: DASHBOARD_TYPE.COMPARE,
          unsaved: true,
          id: id.toString(),
          name,
          isSharing: true,
        },
      }),
      put({
        type: SAVE_DASHBOARD_PROMPT_VISIBILITY,
        flag: false,
        id: id.toString(),
      }),
    ]);
  } catch (err) {
    console.error(err);
    throw err;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.COMPARE_SHARING_INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_COMPARE_SHARING], fetching);
}

function* watchAddCompareSharingTab() {
  yield takeLatest([types.ADD_COMPARE_SHARING_TAB], addCompareSharingTab);
}
export default [watchInitRequest, watchFetching, watchAddCompareSharingTab];
